module.exports = __webpack_public_path__ + "img/d3b1dbc.png";